import React, {Fragment,useContext} from "react";


import OrgProfileForm from "../components/ui/form-org-profile.js";
import { useDeleteOrg, useUpdateOrg, useCreateOrg, useGetOrgs } from "../api/orgs.js";
import ListEditComponent from "../components/ui/component-list-edit.js";
import OrgEditList from "../components/ui/list-edit-org.js";

import SnackbarContext from "../context/snackbar-context.js";
import { handleDisplayResponseResults } from "../api/api_util.js";

export default function ManageOrgPage() {




  const snackbarContext=useContext(SnackbarContext);

  const createOrg = useCreateOrg();

  const updateOrg = useUpdateOrg();

  const deleteOrg = useDeleteOrg();

  const formatCreateSuccess = (result) => `Organization ${result.item.orgName} was created`
  const formatCreateError = (result) => `Organization ${result.item.orgName} could not be created`

  const formatUpdateSuccess = (result) => `Organization ${result.item.orgName} was updated`
  const formatUpdateError = (result) => `Organization ${result.orgName} could not be updated`

  const formatDeleteSuccess = (result) => `Organization ${result.item.orgName} was deleted`
  const formatDeleteError = (result) => `Organization ${result.item.orgName} could not be deleted`



  const handleCreate = async (orgData) => {

    try {
      const response = await createOrg(orgData);
      console.log('Create Response:', response);
      handleDisplayResponseResults(response, snackbarContext, formatCreateSuccess, formatCreateError)
    } catch (error) {
      console.error('Error:', error);
      snackbarContext.openSnackbarError(JSON.stringify(error))
    }
  };




  const handleUpdate = async (updatedData) => {
    try {

      const response = await updateOrg(updatedData);
      console.log('Update Response:', response);
      handleDisplayResponseResults(response, snackbarContext, formatUpdateSuccess,formatUpdateError)
    } catch (error) {
      console.error('Error:', error);
      snackbarContext.openSnackbarError(JSON.stringify(error))
    }
  };


  const handleDelete = async (orgData) => {
    try {
      const orgID=orgData.orgID
      console.log(`in handleDelete, orgID=${JSON.stringify(orgID)}`)
      const response = await deleteOrg(orgID);
      console.log('Delete Response:', response);
      handleDisplayResponseResults(response, snackbarContext, formatDeleteSuccess, formatDeleteError)
    } catch (error) {
      console.error('Error:', error);
      snackbarContext.openSnackbarError(JSON.stringify(error))
    }
  };


  return (
    <Fragment>
    <ListEditComponent editForm={OrgProfileForm} objectLabel="Organization" editList={OrgEditList} useGetList={useGetOrgs} createHandler={handleCreate} updateHandler={handleUpdate} deleteHandler={handleDelete} />
    </Fragment>
  );
};